import React, { ReactNode } from "react";

const Layout: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <main className="app-main-content">
      {children}
    </main>
  );
};

export default Layout;